import { Form, Flex, Input, Button, Checkbox } from "antd";

import CustomSelect from "@/components/inputs/CustomSelect";
import TrashIcon from "@/icons/TrashIcon";
import PlusIcon from "@/icons/PlusIcon";

const TYPE_OPTIONS = [
  {
    value: "text",
    label: "Строка",
  },
  {
    value: "number",
    label: "Число",
  },
  {
    value: "date",
    label: "Дата",
  },
  {
    value: "status",
    label: "Статус",
  },
  {
    value: "employee",
    label: "Сотрудник",
  },
  {
    value: "unit",
    label: "Рабочая группа",
  },
  {
    value: "object",
    label: "Объект системы",
  },
];

const FiltersList = ({ name = "filters", definitionsOptions }) => {
  return (
    <Form.List name={name}>
      {(fields, { add, remove }) => (
        <Flex vertical gap={10}>
          {fields.map(({ key, name: idx, ...restField }) => (
            <Flex key={key} align="start" gap={10}>
              <Form.Item
                {...restField}
                name={[idx, "name"]}
                rules={[{ required: true, message: "Введите имя фильтра" }]}
                style={{ marginBottom: 0 }}
              >
                <Input placeholder="Имя переменной" />
              </Form.Item>

              <Form.Item
                {...restField}
                name={[idx, "title"]}
                rules={[
                  { required: true, message: "Введите заголовок фильтра" },
                ]}
                style={{ marginBottom: 0 }}
              >
                <Input placeholder="Заголовок" />
              </Form.Item>

              <Flex vertical gap={5}>
                <Form.Item
                  {...restField}
                  name={[idx, "type"]}
                  rules={[{ required: true, message: "Выберите тип" }]}
                  style={{ marginBottom: 0, width: 200 }}
                >
                  <CustomSelect
                    placeholder="Тип"
                    optionFilterProp="label"
                    options={TYPE_OPTIONS}
                    allowClear={false}
                  />
                </Form.Item>

                {/* Показываем селект "Объект" только если выбран тип object */}
                <Form.Item noStyle shouldUpdate>
                  {({ getFieldValue }) => {
                    const type = getFieldValue([name, idx, "type"]);
                    if (type !== "object") return null;

                    return (
                      <Form.Item
                        {...restField}
                        name={[idx, "object_uuid"]}
                        rules={[{ required: true, message: "Выберите объект" }]}
                        style={{ marginBottom: 0, width: 200 }}
                        preserve={false}
                      >
                        <CustomSelect
                          placeholder="Объект"
                          optionFilterProp="name"
                          fieldNames={{ value: "uuid", label: "name" }}
                          options={definitionsOptions}
                          allowClear={false}
                        />
                      </Form.Item>
                    );
                  }}
                </Form.Item>
              </Flex>

              <Form.Item
                {...restField}
                name={[idx, "isRequired"]}
                valuePropName="checked"
                style={{ marginBottom: 0 }}
              >
                <Checkbox>Обязательный</Checkbox>
              </Form.Item>

              <Button
                type="text"
                aria-label="Удалить фильтр"
                icon={<TrashIcon />}
                onClick={() => remove(idx)}
                style={{ marginLeft: "auto" }}
              ></Button>
            </Flex>
          ))}

          <Button
            icon={<PlusIcon />}
            type="dashed"
            aria-label="Добавить фильтр"
            onClick={() =>
              add({
                name: "",
                title: "",
              })
            }
          >
            Добавить фильтр
          </Button>
        </Flex>
      )}
    </Form.List>
  );
};

export default FiltersList;
